import { useHydrated } from '@/hooks/use-hydrated'

/**
 * The hydration gate for TEXT-ENTRY controls — the typing counterpart to `ButtonPrimitive`'s gate for clicks.
 * Every field here is CONTROLLED, so characters typed before React binds `onChange` land in the DOM node and
 * nowhere else, leaving a control displaying text the app never sees. The `html[data-hydrated]` barrier cannot
 * cover it — a field inside a streaming Suspense boundary hydrates in a later commit.
 * CREDENTIAL FIELDS ARE EXEMPT: password managers fill them before hydration and skip disabled fields without
 * retrying, and login/register hydrate with the root anyway.
 */
const CREDENTIAL_AUTOCOMPLETE = new Set(['username', 'current-password', 'new-password'])

export function useTextEntryHydration(props: { disabled?: boolean; autoComplete?: string }): {
  'disabled'?: boolean
  'data-hydrating'?: string
} {
  const hydrated = useHydrated()
  const exempt = !!props.autoComplete && CREDENTIAL_AUTOCOMPLETE.has(props.autoComplete)
  if (hydrated || exempt) return { disabled: props.disabled }
  // The flag is only for the fields WE disabled — one the caller disabled must keep its disabled styling.
  return { 'disabled': true, 'data-hydrating': props.disabled ? undefined : '' }
}
